<div class="wa-flank:start">
  <wa-button (click)="fix.emit(staffmember())" appearance="plain" label="fix" size="s" variant="success">
      <wa-icon name="left-from-line" variant="classic"></wa-icon>
    </wa-button>
  <div class="wa-flank:end">
  <div>{{ staffmember().last_name }}, {{ staffmember().first_name }}</div>
  <wa-button (click)="exclude.emit(staffmember())" appearance="plain" label="to regular pool" size="s"
               variant="danger">
      <wa-icon name="right-from-line" variant="classic"></wa-icon>
    </wa-button>
    </div>
  </div>
